export default __webpack_public_path__ + "static/media/plus.abf093da.svg";